import React from 'react'
import PropTypes from 'prop-types'

import GoogleMediaFilesPreview from '../../../../GoogleMediaFilesPreview'

import { getSquareLogoData } from '../HeadlinesSection/helpers'

const SquareLogoSectionPreview = ({ data }) => {
  const { assets } = data
  const squareLogoData = getSquareLogoData(assets)

  return <GoogleMediaFilesPreview assets={squareLogoData} />
}

SquareLogoSectionPreview.propTypes = {
  data: PropTypes.object
}

export default SquareLogoSectionPreview
